import { useState } from "react";
import { useMobileDetect } from "../../hooks";

import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";

import CriaDeQuebradaPopUp from "../../_assets/cria-de-quebrada/Cria_de_Quebrada_Pop_Up.png";
import CriaDeQuebradaPopUpVertical from "../../_assets/cria-de-quebrada/Cria_de_Quebrada_Pop_Up_vertical.png";
import { returnEnvironment } from "../../utils";

const isFavela = returnEnvironment() === "favela";

export const FavelaOnboardingPopup = () => {
    const [isOpen, setIsOpen] = useState(true);
    const isMobile = useMobileDetect();

    const popUpImage = isMobile ? CriaDeQuebradaPopUpVertical : CriaDeQuebradaPopUp;

    if (!isFavela || !isOpen) return null;

    return (
        <Modal
          open={isOpen}
          onClose={() => setIsOpen(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
          }}
        >
          <div
            style={{
              background: 'transparent',
              border: 'none',
              outline: 'none',
              maxWidth: '90vw',
              maxHeight: '90vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
            }}
          >
            <Close
              onClick={() => setIsOpen(false)}
              style={{
                position: 'absolute',
                top: 10,
                right: 10,
                color: 'white',
                fontSize: 24,
                cursor: 'pointer',
                zIndex: 1000,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                borderRadius: '50%',
                padding: '5px',
              }}
            />
            <img
              src={popUpImage}
              alt="Cria de Quebrada"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                cursor: 'pointer',
              }}
              onClick={() => setIsOpen(false)}
            />
          </div>
        </Modal>
    );
};
